import { Pipe, PipeTransform } from '@angular/core';
import { NormalizerHelper } from 'src/app/core/helpers/normalizer.helper';

@Pipe({
  name: 'toNumberOrNull',
})
export class ToNumberOrNullPipe implements PipeTransform {
  transform(value: any): number | null {
    return NormalizerHelper.toNumberOrNull(value);
  }
}
